/**
 * Countdown timer custom element.
 * Ported from Basecamp (src/components/custom-elements/countdown.ts), converted to this repo's
 * colocated self-registering pattern.
 */
class CountdownElement extends HTMLElement {
  constructor() {
    super()
    this.timer = null
    this.endTime = 0
    this.last = {}
    this.isVisible = false
    this.updateCountdown = this.updateCountdown.bind(this)
  }

  connectedCallback() {
    this.units = {
      days: this.querySelector('[data-countdown-days]'),
      hours: this.querySelector('[data-countdown-hours]'),
      minutes: this.querySelector('[data-countdown-minutes]'),
      seconds: this.querySelector('[data-countdown-seconds]')
    }

    const endDate = this.getAttribute('data-end-date')
    if (!endDate) return

    this.endTime = new Date(endDate).getTime()
    if (Number.isNaN(this.endTime) || this.endTime - Date.now() <= 0) {
      this.setAttribute('data-ui', 'hidden')
      return
    }

    this.updateCountdown()
    this.timer = window.setInterval(this.updateCountdown, 1000)
  }

  disconnectedCallback() {
    this.clearTimer()
  }

  clearTimer() {
    if (!this.timer) return
    clearInterval(this.timer)
    this.timer = null
  }

  updateCountdown() {
    const timeDiff = this.endTime - Date.now()

    if (timeDiff < 1) {
      this.clearTimer()
      if (this.isVisible) {
        this.isVisible = false
        this.setAttribute('data-ui', 'hidden')
      }
      return
    }

    const next = {
      days: Math.floor(timeDiff / 86400000),
      hours: Math.floor((timeDiff % 86400000) / 3600000),
      minutes: Math.floor((timeDiff % 3600000) / 60000),
      seconds: Math.floor((timeDiff % 60000) / 1000)
    }

    const keys = Object.keys(next)
    const changed = keys.filter((key) => {
      const value = String(next[key]).padStart(2, '0')
      if (this.last[key] === value) return false
      this.last[key] = value
      return true
    })

    if (!changed.length && this.isVisible) return

    /** Batched so a per-second tick never interleaves writes with layout reads. */
    requestAnimationFrame(() => {
      changed.forEach((key) => {
        if (this.units[key]) this.units[key].textContent = this.last[key]
      })
      if (!this.isVisible) {
        this.isVisible = true
        this.setAttribute('data-ui', 'visible')
      }
    })
  }
}

if (!customElements.get('x-countdown')) customElements.define('x-countdown', CountdownElement)

export default CountdownElement
